
export const generateDefaultFieldArray = fields => {
    let newArray = [];
    fields.map((colField) => {
        if (!colField.isDefault)
            newArray.push(colField.fieldId);
    });
    return newArray;
};

export const generateFixedColumns = columnsDto => {
    let fixedColumns = columnsDto.filter(fixedCols => fixedCols.isFixed);
    return fixedColumns;
}

export const generateAvailableColumns = columnsDto => {
    let availableColumns = columnsDto.filter(availableCols => !availableCols.isFixed);
    return availableColumns;
}

export const generateColumnSeqeuenceNo = columns => {
    let fixedColumn = [];
    columns.map((column, index) => {
        return fixedColumn.push({
            ...column,
            sequence: index + 1,
        });
    });
    return fixedColumn;
}

export const calculateFixedColumnValue = columns => {
    let field = [];
    columns.map(col => {
        return field.push({
            ...col,
            isFixed: true,
        });
    });
    return field;
}

export const calculateAvailableColumnValue = columns => {
    let field = [];
    columns.map(col => {
        return field.push({
            ...col,
            isFixed: false,
        });
    });
    return field;
}

export const generateSaveColumnListRequest = (columnsDto, selectedColumns, listingMaster,selectedTab) => {
    let userFields;
    let fields = [];
    columnsDto.map((aCol) => {
        return fields.push({
            fieldDisplayName: aCol.fieldDisplayName,
            fieldId: aCol.fieldId,
            fieldName: aCol.fieldName,
            isDefault: !selectedColumns.includes(aCol.fieldId),
            isFixed: aCol.isFixed,
            sequence: aCol.sequence,
        });
    });
    userFields = {
        fields,
        listingMaster,
        tab:(selectedTab.replaceAll(" ","_"))
    };

    return userFields;
}